import * as React from "react";
export const CartoContext = React.createContext(
  // default values used by a Consumer when it does not have a
  // matching Provider above it in the tree, useful for testing
  {
    CartoContext: {
      carto: 'default',
    }
  }
);
